import { ANONYMOUS_USER } from "@vsf-enterprise/sapcc-api";
import { anonymousCartUtils } from "~/helpers/anonymous-cart-utils";
// eslint-disable-next-line func-names
export default async function (context) {
  const {
    app: { $cookies, $vsf, router },
    route,
  } = context;
  const {
    anonymousCartRoutes,
    isCartUserAnonymous,
    getCart,
    isCartUserCookieExist,
  } = anonymousCartUtils({
    $cookies,
    $vsf,
  });

  const isCartUserCookieSet = isCartUserCookieExist();

  if (anonymousCartRoutes.includes(route.name) && !isCartUserCookieSet) {
    const cart = await getCart();
    if (cart.user.uid !== ANONYMOUS_USER) {
      await router.push({
        name: "Checkout/Shipping",
        query: { login: true, redirect: "Checkout/Shipping" },
      });
      return;
    }
  }

  if (anonymousCartRoutes.includes(route.name) && !isCartUserAnonymous()) {
    await router.push({
      name: "Checkout/Shipping",
      query: { login: true, redirect: route.name },
    });
  }
}
